import { useEffect, useState } from 'react';

/* This hook specifically addresses sticky button issues with safari web browser.
 * Safari browser will render a banner prompting the user to download the app.
 * That banner is rendered outside the DOM, and pushes the DOM down. If fixed position
 * bottom: 0 is used for a sticky item, then the position will be pushed off the screen
 * This recitifies that by calculating the bottom position if the viewport size is
 * different from the client size. It is throttled to avoid perfromance issues
 * on Safari */

function getFixedBottomWindowPositionThrottled(
  setBottomPos: (num: number) => void
) {
  return function () {
    const { innerHeight } = window;
    const html = document.querySelector('html') as HTMLHtmlElement;
    const { clientHeight } = html;
    const now = new Date();
    let lastTime = 0;
    const TIME_FRAME = 16; //milliseconds
    if (now.getTime() - lastTime >= TIME_FRAME) {
      if (clientHeight > innerHeight) {
        setBottomPos(clientHeight - innerHeight);
      }

      setBottomPos(0);
      lastTime = now.getTime();
    }
  };
}

export function useFixedBottomPosition() {
  const [bottomPos, setBottomPos] = useState(0);
  useEffect(() => {
    window.addEventListener(
      'touchmove',
      getFixedBottomWindowPositionThrottled(setBottomPos)
    );
    window.addEventListener(
      'resize',
      getFixedBottomWindowPositionThrottled(setBottomPos)
    );

    return () => {
      window.removeEventListener(
        'touchmove',
        getFixedBottomWindowPositionThrottled(setBottomPos)
      );
      window.removeEventListener(
        'resize',
        getFixedBottomWindowPositionThrottled(setBottomPos)
      );
    };
  }, []);

  useEffect(() => {
    getFixedBottomWindowPositionThrottled(setBottomPos)();
  });

  return { bottomPos };
}
